import { Collapse } from "@mui/material";
import { InputCheck } from "controls";
import React, { useEffect } from "react";

const SupplierAccess = ({ values, setValues }) => {
  useEffect(() => {
    if (!values.id) {
      values.supplierAccess
        ? setValues((j) => ({
            ...j,
            supplier: {
              create: true,
              edit: true,
              delete: true,
              paymentReceive: true,
            },
          }))
        : setValues((j) => ({
            ...j,
            supplier: {
              create: false,
              edit: false,
              delete: false,
              paymentReceive: false,
            },
          }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.supplierAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setValues((j) => ({
      ...j,
      supplier: { ...j.supplier, [name]: checked },
    }));
  };

  return (
    <Collapse in={values.supplierAccess || false}>
      <div className="ml-[3px] grid gap-1 mt-[2px] mb-[10px] !uppercase tracking-wider !pl-[10px] border-l-4  border-rounded">
        <InputCheck
          label="Create"
          checked={values.supplier?.create || false}
          name={"create"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Edit"
          checked={values.supplier?.edit || false}
          name={"edit"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Delete"
          checked={values.supplier?.delete || false}
          name={"delete"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Payment Receive"
          checked={values.supplier?.paymentReceive || false}
          name={"paymentReceive"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default SupplierAccess;
